import React from 'react';

interface BuildingScreen3DIconProps {
  size?: number;
  color?: string;
}

export const BuildingScreen3DIcon = ({ size = 48, color = '#BC1A6C' }: BuildingScreen3DIconProps) => {
  const darkerColor = adjustBrightness(color, -30);
  const lighterColor = adjustBrightness(color, 30);

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="32" cy="58" rx="18" ry="3" fill="rgba(0,0,0,0.2)" />
      {/* Building body */}
      <rect x="10" y="8" width="36" height="48" rx="2" fill="#6B7280" />
      <path d="M46 8 L50 5 L50 53 L46 56 Z" fill="#4B5563" />
      <path d="M10 8 L14 5 L50 5 L46 8 Z" fill="#9CA3AF" />
      {/* Windows row 1 */}
      <rect x="14" y="12" width="6" height="5" rx="1" fill="#D1D5DB" opacity="0.5" />
      <rect x="24" y="12" width="6" height="5" rx="1" fill="#D1D5DB" opacity="0.5" />
      <rect x="34" y="12" width="6" height="5" rx="1" fill="#D1D5DB" opacity="0.5" />
      {/* Windows row 2 */}
      <rect x="14" y="20" width="6" height="5" rx="1" fill="#D1D5DB" opacity="0.4" />
      <rect x="24" y="20" width="6" height="5" rx="1" fill="#D1D5DB" opacity="0.4" />
      <rect x="34" y="20" width="6" height="5" rx="1" fill="#D1D5DB" opacity="0.4" />
      {/* Mounted screen on building face */}
      <rect x="12" y="30" width="30" height="18" rx="2" fill={color} />
      <path d="M42 30 L44 28 L44 46 L42 48 Z" fill={darkerColor} />
      <path d="M12 30 L14 28 L44 28 L42 30 Z" fill={lighterColor} />
      {/* Screen inner */}
      <rect x="15" y="33" width="24" height="12" rx="1" fill="white" opacity="0.25" />
      {/* Play icon */}
      <polygon points="24,36 24,42 30,39" fill="white" opacity="0.5" />
      {/* Screen shine */}
      <rect x="12" y="30" width="30" height="3" rx="2" fill="white" opacity="0.15" />
      {/* Building door */}
      <rect x="26" y="50" width="8" height="6" rx="1" fill="#4B5563" />
    </svg>
  );
};

function adjustBrightness(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
